const prefix = "LEVY_COLLECTION_RISK_FACTOR_";

export const CREATE = prefix + "CREATE";
export const DELETE = prefix + "DELETE";
export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";
export const VIEW = prefix + "VIEW";
